export const NavigationHelpers = {
  redirectToPaytm: url => {
    window.location = url;
  }
};
